import { UserSearch, Stethoscope, HeartHandshake, Trophy, Activity, Zap, Home, Brain, Users } from "lucide-react";
import { StaggerGroup, StaggerItem, Reveal } from "@/components/ScrollReveal";
import { CURSUS_PERSONAS } from "@/lib/cursusMeta";

const ICONS = { UserSearch, Stethoscope, HeartHandshake, Trophy, Activity, Zap, Home, Brain, Users };

export default function CursusPersonas({ slug }) {
    const personas = CURSUS_PERSONAS[slug] || [];
    return (
        <section
            className="relative overflow-hidden bg-brand-ink py-24 text-white md:py-32"
            data-testid="cursus-personas"
        >
            <div className="absolute inset-0 grain pointer-events-none opacity-25" />
            <div className="relative mx-auto max-w-7xl px-6">
                <Reveal>
                    <span className="text-[11px] font-semibold uppercase tracking-[0.32em] text-brand-orange">
                        Pour qui
                    </span>
                    <h2 className="mt-5 max-w-4xl font-display font-normal leading-[0.95] tracking-tightest text-[40px] sm:text-5xl lg:text-[72px]">
                        Pour qui ce cursus <em className="italic text-white/55">est fait.</em>
                    </h2>
                </Reveal>

                <StaggerGroup stagger={0.12} className="mt-16 grid grid-cols-1 gap-5 md:grid-cols-3">
                    {personas.map((p) => {
                        const Icon = ICONS[p.icon] || UserSearch;
                        return (
                            <StaggerItem key={p.title}>
                                <div
                                    className="group h-full rounded-3xl border border-white/10 bg-white/[0.03] p-8 transition-all duration-500 hover:-translate-y-1 hover:border-brand-orange/35 hover:bg-white/[0.05]"
                                    data-testid={`persona-${p.title.split(" ").join("-").toLowerCase()}`}
                                >
                                    <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-orange/15 text-brand-orange transition-transform duration-500 group-hover:-rotate-6">
                                        <Icon className="h-6 w-6" />
                                    </div>
                                    <div className="mt-8 font-display text-xl leading-tight text-white md:text-2xl">
                                        {p.title}
                                    </div>
                                    <div className="mt-4 text-sm leading-relaxed text-white/65">
                                        {p.text}
                                    </div>
                                </div>
                            </StaggerItem>
                        );
                    })}
                </StaggerGroup>
            </div>
        </section>
    );
}
